export var deliveryMethodMaxMessageLength = {
    SMS: 980,
};
//# sourceMappingURL=delivery-method-constants.js.map